import { data } from "../data";

export const getUser = () => async (dispatch) => {
  try {
    dispatch({
      type: "GET_USER_REQUEST",
    });

    // Simulate delay
    setTimeout(() => {
      dispatch({
        type: "GET_USER_SUCCESS",
        payload: data.user,
      });
    }, 500);

  } catch (error) {
    dispatch({
      type: "GET_USER_FAILURE",
      payload: error.response?.data?.message || "Error",
    });
  }
};

export const login = (email, password) => async (dispatch) => {
  // Static app - login disabled or mocked
  alert("Login is disabled in static mode.");
  dispatch({ type: "LOGIN_FAILURE", payload: "Login disabled in static mode" });
};

export const logout = () => async (dispatch) => {
  dispatch({ type: "LOGOUT_SUCCESS", payload: "Logged out" });
};

export const loadUser = () => async (dispatch) => {
  try {
    dispatch({
      type: "LOAD_USER_REQUEST",
    });

    // For static, maybe just load the same user data or fail silently
    // dispatch({
    //   type: "LOAD_USER_SUCCESS",
    //   payload: data.user,
    // });

    // Actually, usually loadUser checks if we are logged in.
    // In static mode, we are never logged in as admin unless we hardcode it.
    // Let's fail it so we are not admin.
    dispatch({
      type: "LOAD_USER_FAILURE",
      payload: "Not logged in",
    });

  } catch (error) {
    dispatch({
      type: "LOAD_USER_FAILURE",
      payload: error.response?.data?.message || "Error",
    });
  }
};

export const updateUser =
  (name, email, password, skills, about) => async (dispatch) => {
    alert("Update disabled in static mode.");
  };

export const addTimeline = (title, description, date) => async (dispatch) => {
  alert("Add Timeline disabled in static mode.");
};

export const deleteTimeline = (id) => async (dispatch) => {
  alert("Delete Timeline disabled in static mode.");
};

export const addYoutube = (title, url, image) => async (dispatch) => {
  alert("Add Youtube disabled in static mode.");
};

export const deleteYoutube = (id) => async (dispatch) => {
  alert("Delete Youtube disabled in static mode.");
};

export const addProject =
  (title, url, image, description, techStack) => async (dispatch) => {
    alert("Add Project disabled in static mode.");
  };

export const deleteProject = (id) => async (dispatch) => {
  alert("Delete Project disabled in static mode.");
};

export const contactUs = (name, email, message) => async (dispatch) => {
  alert(`Message sent (simulated): ${message}`);
  dispatch({
    type: "CONTACT_US_SUCCESS",
    payload: "Message Sent Successfully (Static Mode)",
  });
};
